import formIdPropsMixin from './formIdProps';

export default {
  mixins: [formIdPropsMixin],
  computed: {
    inputId () {
      return this.id ? this.id : this.$id('input');
    },
  },
};
